__webpack_require__.p = "/sf6becktrainingportal/";